import React, { useEffect, useState } from "react";
import * as Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import LinearChart from "../../../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart"
import { applyTip } from "@utils/utils";
import HCSoldGauge from "highcharts/modules/solid-gauge";
import { CropConditionData } from "@baseTypes/service/dashboard/IScoutingDashboardService";
import BaseChartTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";
import {
    RowWithAreaFormatter,
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";
import {
    addDataLabels,
    toggleSeriesOnMouseBackgroundInteraction,
    toggleSeriesOpacity,
} from "@pages/dashboard/statecrops/chart/utils";

HC_more(Highcharts);
HCSoldGauge(Highcharts);


interface CropsConditionChartProps {
    data: CropConditionData
}

const CropsConditionChart = (props: CropsConditionChartProps) => {
    const [chartOptions, setChartOptions] = useState<Highcharts.Options>({ title: { text: '' } })
    const { data } = props

    const calcOuterRadius = (i: number) => 100 - i * 25 + "%"
    const calcInnerRadius = (i: number) => 85 - i * 25 + "%"

    useEffect(() => {
        const totalHa = data.total
        const defaultOptions: Highcharts.Options = {
            chart: {
                animation: {
                  duration: 0
                },
                height: 198,
                margin: 0,
                spacing: [0, 0, 0, 0],
                type: 'solidgauge',
                events: {
                    render: function () {
                        addDataLabels(this, data.fieldConditions)
                        toggleSeriesOnMouseBackgroundInteraction(this)
                    }
                }
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: false
            },
            pane: {
                size: '100%',
                endAngle: 270,
                startAngle: 0,
                background: data.fieldConditions.map((condition, i) => ({
                    outerRadius: calcOuterRadius(i),
                    innerRadius: calcInnerRadius(i),
                    backgroundColor: new Highcharts.Color(condition.color).setOpacity(0.3).get(),
                    borderWidth: 0,
                    shape: 'arc',
                    borderRadius: '50%'
                })),
            },
            tooltip: applyTip((ctx) => {
                // @ts-ignore
                return <BaseChartTooltip elements={[ctx.point].map(child => ({
                                            // @ts-ignore
                                            id: `${child.custom.name}-${child.y}-${child.x}`,
                                            color: child.color,
                                            // @ts-ignore
                                            name: child.custom.name,
                                            // @ts-ignore
                                            area: child.custom.trueValue,
                                            dimension: ' Га'
                                         }))}
                                         cellsInRow={2}
                                         RowFormatter={RowWithAreaFormatter} />
            }, {
                followPointer: true,
            }),
            yAxis: {
                lineWidth: 0,
                min: 0,
                max: 100,
                tickPositions: []
            },
            plotOptions: {
                solidgauge: {
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true,
                    events: {
                        mouseOver: function () {
                            toggleSeriesOpacity(this.chart, 0, this.index)
                        },
                        mouseOut: function () {
                            toggleSeriesOpacity(this.chart, 1)
                        }
                    },
                    inactiveOtherPoints: true
                },
                series: {
                    // скорее всего баг Highcharts, без этого свойства нельзя повернуть график по часовой стрелке
                    clip: false
                }
            },
            // @ts-ignore
            series: data.fieldConditions.map((condition, i) => ({
                data: [{
                    color: condition.color,
                    y: condition.total / totalHa * 100,
                    radius: calcOuterRadius(i),
                    innerRadius: calcInnerRadius(i),
                    custom: {
                        name: condition.type,
                        trueValue: condition.total
                    }
                }],
                dataLabels: {
                    enabled: false
                }
            })),
        }
        setChartOptions(defaultOptions as Highcharts.Options)
    }, [data])


    return <LinearChart options={chartOptions}/>
}


export default CropsConditionChart;